// extracted by mini-css-extract-plugin
module.exports = {"container":"gift-item-skeleton_container__JyjYe"};